import { LocaleStore } from '@portal/schema/locale';
import { StoreCode } from '@portal/schema/storeCode';
import { useLocale } from '@portal/shared/hooks/useLocale';

const customCountryCode: Partial<Record<StoreCode, string>> = {
  au: 'AU',
  aud: 'AU',
  nz: 'NZ',
  nzd: 'NZ',
  uk: 'GB',
  ukd: 'GB',
  eu: 'FR', // default to FR for EU
  eud: 'FR' // default to FR for EU
};

export const mapStoreCodeToCountryCode = (storeCode: StoreCode): string =>
  customCountryCode[storeCode] || 'US';

export function useStoreCountryCode() {
  const locale = useLocale();
  const store = LocaleStore[locale];

  return mapStoreCodeToCountryCode(store);
}
